export const toNumber = (value: string) => {
  const valueAsNumber = parseInt(value);
  if (!isNaN(valueAsNumber)) {
    return valueAsNumber;
  }
  return undefined;
};
